{
  "COMPOSE_REDIRECT": {
    "OPENING": "Otváram novú konverzáciu s {email}…",
    "NO_EMAIL": "Nebola zadaná e-mailová adresa. Použite ?email=meno@example.com",
    "CONTACT_ERROR": "Kontakt pre {email} sa nepodarilo nájsť."
  },
  "CONVERSATION": {
    "404": "Prepáčte, konverzáciu sa nepodarilo nájsť. Skúste to prosím znova",
    "SELECT_A_CONVERSATION": "Vyberte si konverzáciu z ľavého panela",
    "CSAT_REPLY_MESSAGE": "Prosím, ohodnoťte konverzáciu",
    "SWITCH_VIEW_LAYOUT": "Prepnúť rozloženie",
    "DASHBOARD_APP_TAB_MESSAGES": "Správy",
    "UNVERIFIED_SESSION": "Totožnosť tohto používateľa nie je overená",
    "NO_MESSAGE_1": "Zdá sa, že v doručenej pošte nemáte žiadne správy od zákazníkov.",
    "NO_MESSAGE_2": " poslať správu na svoju stránku!",
    "NO_INBOX_1": "Vyzerá to, že ste ešte nepridali žiadnu schránku.",
    "NO_INBOX_2": " na začiatok",
    "NO_INBOX_AGENT": "Zdá sa, že nie ste súčasťou žiadnej schránky. Obráťte sa na svojho správcu",
    "SEARCH_MESSAGES": "Vyhľadávanie správ v konverzáciách",
    "VIEW_ORIGINAL": "Zobraziť originál",
    "VIEW_TRANSLATED": "Zobraziť preklad",
    "TRANSLATION": "Preklad",
    "EMPTY_STATE": {
      "CMD_BAR": "pre otvorenie príkazového menu",
      "KEYBOARD_SHORTCUTS": "pre zobrazenie klávesových skratiek"
    },
    "SEARCH": {
      "TITLE": "Prehľadávať správy",
      "RESULT_TITLE": "Výsledky vyhľadávania",
      "LOADING_MESSAGE": "Spracúvajú sa dáta...",
      "PLACEHOLDER": "Napíšte niečo pre vyhľadanie správ",
      "NO_MATCHING_RESULTS": "Nenašli sa žiadne výsledky."
    },
    "UNREAD_MESSAGES": "Neprečítané správy",
    "UNREAD_MESSAGE": "Neprečítaná správa",
    "CLICK_HERE": "Kliknite sem",
    "LOADING_INBOXES": "Načítavajú sa schránky",
    "LOADING_CONVERSATIONS": "Načítavajú sa konverzácie",
    "CANNOT_REPLY": "Neviete odpovedať, pretože",
    "24_HOURS_WINDOW": "24-hodinové obmedzenie okna správ",
    "NOT_ASSIGNED_TO_YOU": "Táto konverzácia vám nie je priradená. Chcete si ju priradiť?",
    "ASSIGN_TO_ME": "Prideliť mne",
    "TWILIO_WHATSAPP_CAN_REPLY": "Na túto konverzáciu môžete odpovedať len pomocou šablóny správy z dôvodu",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24-hodinové obmedzenie okna správ",
    "REPLYING_TO": "Odpovedáte na:",
    "REMOVE_SELECTION": "Odstrániť výber",
    "DOWNLOAD": "Stiahnuť",
    "UNKNOWN_FILE_TYPE": "Neznámy súbor",
    "SAVE_CONTACT": "Uložiť kontakt",
    "NO_CONTENT": "Žiadny obsah na zobrazenie",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Pred odoslaním vykonajte:",
      "EXECUTE": "Vykonať",
      "RETRY": "Skúsiť znova",
      "CONFIRM": "Naozaj vykonať?",
      "CONFIRM_YES": "Áno, vykonať",
      "CONFIRM_NO": "Zrušiť",
      "RUNNING": "Prebieha…",
      "DONE": "Vykonané",
      "CLAIM_DELAYED": "založí sa po doručení objednávky",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Založená NOVÁ reklamácia {reference}, {planned} je uzavretá — upravte text návrhu",
        "NEW_CLAIM": "Založená NOVÁ reklamácia {reference} namiesto doplnenia {planned} — upravte text návrhu",
        "OTHER_CLAIM": "Doplnená reklamácia {reference} namiesto {planned} — upravte text návrhu",
        "EXISTING_CLAIM": "Nová reklamácia nebola založená, doplnená existujúca {reference} — upravte text návrhu",
        "OTHER": "Prebehlo to inak, ako návrh predpokladal — upravte text návrhu"
      },
      "FAILED": "Nepodarilo sa",
      "UNREACHABLE": "Bot nie je dostupný",
      "REQUEST_FAILED": "Akciu sa nepodarilo spustiť, skúste to prosím znova.",
      "ACTIONS": {
        "CANCEL_ORDER": "Zrušiť objednávku",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Zmeniť platbu na dobierku",
        "CREATE_CLAIM": "Založiť reklamáciu",
        "CREATE_OR_UPDATE_CLAIM": "Založiť alebo upraviť reklamáciu",
        "EXTEND_ORDER_PICKUP_DATE": "Predĺžiť lehotu na vyzdvihnutie"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} zdieľal(a) kontakt",
      "LOCATION": "{sender} zdieľal(a) polohu",
      "FILE": "{sender} zdieľal(a) súbor"
    },
    "UPLOADING_ATTACHMENTS": "Prílohy sa nahrávajú...",
    "REPLIED_TO_STORY": "Odpovedané na váš príbeh",
    "UNSUPPORTED_MESSAGE": "Táto správa nie je podporovaná. Môžete si ju zobraziť v aplikácii Facebook / Instagram.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Táto správa nie je podporovaná. Môžete si ju zobraziť v aplikácii Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Táto správa nie je podporovaná. Môžete si ju zobraziť v aplikácii Instagram.",
    "SUCCESS_DELETE_MESSAGE": "Správa bola úspešne odstránená",
    "FAIL_DELETE_MESSSAGE": "Správu sa nepodarilo vymazať! Skúste to znova",
    "NO_RESPONSE": "Žiadna odpoveď",
    "RESPONSE": "Odpoveď",
    "RATING_TITLE": "Hodnotenia",
    "FEEDBACK_TITLE": "Spätná väzba",
    "REPLY_MESSAGE_NOT_FOUND": "Správa nie je dostupná",
    "CARD": {
      "SHOW_LABELS": "Zobraziť štítky",
      "HIDE_LABELS": "Skryť štítky"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Vyriešiť",
      "REOPEN_ACTION": "Znovu otvoriť",
      "OPEN_ACTION": "Otvoriť",
      "OPEN": "Viac",
      "CLOSE": "Zatvoriť",
      "DETAILS": "detaily",
      "SNOOZED_UNTIL": "Odložené do",
      "SNOOZED_UNTIL_TOMORROW": "Odložené do zajtra",
      "SNOOZED_UNTIL_NEXT_WEEK": "Odložené do ďalšieho týždňa",
      "SNOOZED_UNTIL_NEXT_REPLY": "Odložené do ďalšej odpovede",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "prekročené",
        "DUE": "termín"
      },
      "MORE": "Ďalšie akcie"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Označiť ako čakajúce na vybavenie",
      "SNOOZE_UNTIL": "Odložiť",
      "SNOOZE": {
        "TITLE": "Odložiť do",
        "NEXT_REPLY": "Ďalšia odpoveď",
        "TOMORROW": "Zajtra",
        "NEXT_WEEK": "Ďalší ťýždeň"
      },
      "RESOLVE_WITHOUT_CSAT": "Vyriešiť bez CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Odložiť do",
      "APPLY": "Odložiť",
      "CANCEL": "Zrušiť"
    },
    "PRIORITY": {
      "TITLE": "Priorita",
      "OPTIONS": {
        "NONE": "Žiadne",
        "URGENT": "Urgentné",
        "HIGH": "Vysoká",
        "MEDIUM": "Stredná",
        "LOW": "Nízka"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Žiadne",
        "INPUT_PLACEHOLDER": "Vyberte prioritu",
        "NO_RESULTS": "Žiadne výsledky neboli nájdené",
        "SUCCESSFUL": "Priorita konverzácie {conversationId} bola zmenená na {priority}",
        "FAILED": "Nepodarilo sa zmeniť prioritu. Skúste to prosím znova."
      }
    },
    "SLA": {
      "BREACHED": "porušené"
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Otvoriť na novej karte",
      "COPY_LINK": "Kopírovať odkaz na konverzáciu",
      "COPY_LINK_SUCCESS": "Odkaz na konverzáciu bol skopírovaný do schránky",
      "PENDING": "Označiť ako čakajúce na vybavenie",
      "RESOLVED": "Označiť ako vyriešené",
      "MARK_AS_UNREAD": "Označiť ako neprečítané",
      "MARK_AS_READ": "Označiť ako prečítané",
      "REOPEN": "Znovu otvoriť konverzáciu",
      "SNOOZE": {
        "TITLE": "Odložiť",
        "NEXT_REPLY": "Do ďalšej odpovede",
        "TOMORROW": "Do zajtra",
        "NEXT_WEEK": "Do budúceho týždňa"
      },
      "ASSIGN_AGENT": "Priradiť agenta",
      "ASSIGN_LABEL": "Priradiť štítok",
      "AGENTS_LOADING": "Načítavajú sa agenti...",
      "ASSIGN_TEAM": "Priradiť tím",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Konverzácia {conversationId} bola priradená agentovi \"{agentName}\"",
          "FAILED": "Nepodarilo sa priradiť agenta. Skúste to prosím znova."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Konverzácii {conversationId} bol priradený štítok #{labelName}",
          "FAILED": "Nepodarilo sa priradiť štítok. Skúste to prosím znova."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Konverzácii {conversationId} bol priradený tím \"{team}\"",
          "FAILED": "Nepodarilo sa priradiť tím. Skúste to prosím znova."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Podpis správy",
      "ENABLE_SIGN_TOOLTIP": "Povoliť podpis",
      "DISABLE_SIGN_TOOLTIP": "Zakázať podpis",
      "MSG_INPUT": "Shift + enter pre nový riadok. Ak chcete vybrať Uloženú odpoveď, začnite klávesou '/'.",
      "PRIVATE_MSG_INPUT": "Shift + enter pre nový riadok. Toto bude viditeľné len pre agentov",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Podpis správy nie je nakonfigurovaný, prosím nakonfigurujte ho v nastaveniach profilu.",
      "CLICK_HERE": "Kliknite sem pre aktualizáciu",
      "WHATSAPP_TEMPLATES": "Whatsapp šablóny",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24-hodinové okno WhatsApp vypršalo. Odpovedzte pomocou šablóny.",
      "INSERT_SIGNATURE": "Vložiť podpis do editora",
      "SIGNATURE_PREVIEW_IMAGE": "(podpis s obrázkom)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Zdá sa, že vaša odpoveď je v jazyku {draftLanguage}, ale táto konverzácia je v jazyku {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Preložiť",
      "REPLY": "Odpovedať",
      "PRIVATE_NOTE": "Súkromná správa",
      "SEND": "Poslať",
      "CREATE": "Pridať poznámku",
      "INSERT_READ_MORE": "Čítať viac",
      "DISMISS_REPLY": "Zrušiť odpoveď",
      "REPLYING_TO": "Odpovedá sa na:",
      "TIP_FORMAT_ICON": "Zobraziť rozšírený textový editor",
      "TIP_EMOJI_ICON": "Zobraz výber emotikonov",
      "TIP_ATTACH_ICON": "Pripojiť súbory",
      "TIP_AUDIORECORDER_ICON": "Nahrať zvuk",
      "TIP_AUDIORECORDER_PERMISSION": "Povoliť prístup k zvuku",
      "TIP_AUDIORECORDER_ERROR": "Nepodarilo sa otvoriť zvuk",
      "DRAG_DROP": "Potiahnite sem na pripojenie",
      "START_AUDIO_RECORDING": "Začať nahrávanie zvuku",
      "STOP_AUDIO_RECORDING": "Zastaviť nahrávanie zvuku",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Pridať skrytú kópiu",
        "CC": {
          "LABEL": "Kópia",
          "PLACEHOLDER": "E-maily oddelené čiarkami",
          "ERROR": "Zadajte platné e-mailové adresy"
        },
        "BCC": {
          "LABEL": "Skrytá kópia",
          "PLACEHOLDER": "E-maily oddelené čiarkami",
          "ERROR": "Zadajte platné e-mailové adresy"
        },
        "EDIT": "Upraviť",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Skryť",
        "INCLUDE_ORIGINAL_MESSAGE": "Zahrnúť pôvodnú správu",
        "EDIT_HEADERS": "Upraviť",
        "HIDE_HEADER_EDITS": "Skryť úpravy",
        "SUBJECT": {
          "LABEL": "PREDMET",
          "PLACEHOLDER": "Predmet e-mailu",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Nedefinované premenné",
        "MESSAGE": "Vo vašej správe máte {undefinedVariablesCount} nedefinovaných premenných: {undefinedVariables}. Chcete správu napriek tomu odoslať?",
        "CONFIRM": {
          "YES": "Poslať",
          "CANCEL": "Zrušiť"
        }
      },
      "SEND_EMAIL": "Odoslať e-mail",
      "SEND_SMS": "Odoslať SMS",
      "NO_SMS_INBOX": "Na odoslanie SMS pridajte SMS schránku.",
      "SEND_CHAT": "Odoslať chat",
      "REPLY_TO_THIS": "Odpovedať na toto",
      "TIP_EXPAND_ICON": "Zväčšiť editor",
      "TIP_COLLAPSE_ICON": "Zmenšiť editor",
      "HEADING_LEVEL": {
        "LABEL": "Štýl textu",
        "NORMAL": "Normálny text",
        "H1": "Nadpis 1",
        "H2": "Nadpis 2",
        "H3": "Nadpis 3"
      },
      "EDITOR": {
        "BOLD": "Tučné",
        "ITALIC": "Kurzíva",
        "UNDERLINE": "Podčiarknuté",
        "TEXT_COLOR": "Farba textu",
        "BG_COLOR_LABEL": "Farba pozadia",
        "FONT_SIZE_LABEL": "Veľkosť písma",
        "FONT_SIZE": {
          "XS": "Malé",
          "SM": "Stredne malé",
          "MD": "Predvolené",
          "LG": "Veľké",
          "XL": "Extra veľké",
          "XXL": "Obrovské"
        },
        "CODE": "Kód",
        "LINK": "Pridať alebo odstrániť odkaz",
        "CREATE_LINK": "Vytvoriť odkaz",
        "SAVE_LINK": "Uložiť",
        "CANCEL": "Zrušiť",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Späť",
        "REDO": "Znova",
        "BULLET_LIST": "Odrážkový zoznam",
        "ORDERED_LIST": "Číslovaný zoznam",
        "BLOCKQUOTE": "Citácia",
        "H1": "Nadpis 1",
        "H2": "Nadpis 2",
        "H3": "Nadpis 3",
        "IMAGE_UPLOAD": "Nahrať obrázok",
        "CLEAR_FORMATTING": "Vymazať formátovanie",
        "COLOR": {
          "RED": "Červená",
          "YELLOW": "Žltá",
          "BLUE": "Modrá",
          "ROSE_RED": "Ružovočervená",
          "DEEP_CYAN": "Tmavá tyrkysová",
          "ORANGE": "Oranžová",
          "PISTACHIO": "Pistáciová",
          "PURPLE": "Fialová",
          "FUCHSIA": "Fuchsiová",
          "SILVER": "Strieborná",
          "NAVY": "Námornícka modrá",
          "OLD_PINK": "Staroružová",
          "AQUA": "Akvamarínová",
          "BROWN": "Hnedá",
          "OLIVE": "Olivová",
          "GOLD": "Zlatá",
          "BEIGE": "Béžová",
          "WINE": "Vínová",
          "FOREST": "Lesná zelená",
          "GREEN": "Zelená",
          "BLUE_GREY": "Modrosivá",
          "RUBY_RED": "Rubínová",
          "CHESTNUT_BROWN": "Gaštanovohnedá",
          "ASH_GREY": "Popolavosivá"
        },
        "BG_COLOR": {
          "RED": "Červená",
          "YELLOW": "Žltá",
          "BLUE": "Modrá",
          "ROSE_RED": "Ružovočervená",
          "DEEP_CYAN": "Tmavá tyrkysová",
          "ORANGE": "Oranžová",
          "PISTACHIO": "Pistáciová",
          "PURPLE": "Fialová",
          "FUCHSIA": "Fuchsiová",
          "SILVER": "Strieborná",
          "NAVY": "Námornícka modrá",
          "OLD_PINK": "Staroružová",
          "AQUA": "Akvamarínová",
          "BROWN": "Hnedá",
          "OLIVE": "Olivová",
          "GOLD": "Zlatá",
          "BEIGE": "Béžová",
          "WINE": "Vínová",
          "FOREST": "Lesná zelená",
          "GREEN": "Zelená",
          "BLUE_GREY": "Modrosivá",
          "RUBY_RED": "Rubínová",
          "CHESTNUT_BROWN": "Gaštanovohnedá",
          "ASH_GREY": "Popolavosivá"
        }
      },
      "COPILOT": {
        "Q": "Požiadať robota o pomoc"
      }
    },
    "VISIBLE_TO_AGENTS": "Súkromná poznámka: Viditeľná iba pre vás a váš tím",
    "CHANGE_STATUS": "Stav konverzácie bol zmenený",
    "CHANGE_STATUS_FAILED": "Zmena stavu konverzácie zlyhala",
    "CHANGE_AGENT": "Pridelenec konverzácie bol zmenený",
    "CHANGE_AGENT_FAILED": "Zmena pridelenca zlyhala",
    "ASSIGN_LABEL_SUCCESFUL": "Štítok bol úspešne priradený",
    "ASSIGN_LABEL_FAILED": "Priradenie štítku zlyhalo",
    "CHANGE_TEAM": "Tím konverzácie bol zmenený",
    "FILE_SIZE_LIMIT": "Súbor presahuje limit prílohy {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "MESSAGE_ERROR": "Túto správu sa nepodarilo odoslať, skúste to prosím neskôr",
    "SENT_BY": "Odoslal(a):",
    "BOT": "Bot",
    "SEND_FAILED": "Správu sa nepodarilo odoslať! Skúste znova",
    "TRY_AGAIN": "skúsiť znova",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Vybrať agenta",
      "REMOVE": "Odstrániť",
      "ASSIGN": "Priradiť"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopírovať",
      "REPLY_TO": "Odpovedať na túto správu",
      "DELETE": "Vymazať",
      "CREATE_A_CANNED_RESPONSE": "Pridať do pripravených odpovedí",
      "TRANSLATE": "Preložiť",
      "COPY_PERMALINK": "Kopírovať odkaz na správu",
      "LINK_COPIED": "URL správy bolo skopírované do schránky",
      "DELETE_CONFIRMATION": {
        "TITLE": "Naozaj chcete odstrániť túto správu?",
        "MESSAGE": "Túto akciu nemožno vrátiť späť",
        "DELETE": "Vymazať",
        "CANCEL": "Zrušiť"
      },
      "FORWARD": "Preposlať",
      "FORWARD_ERROR": "Nepodarilo sa pripraviť preposlanú správu"
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "IMAGE_RESIZE": {
      "SMALL": "Malá",
      "MEDIUM": "Stredná",
      "LARGE": "Veľká",
      "ORIGINAL": "Originálna"
    },
    "SHOW_HIDDEN_MESSAGES": "Zobraziť skryté správy",
    "TRANSCRIPT": {
      "SHOW": "Zobraziť celý prepis",
      "HIDE": "Skryť celý prepis",
      "DOWNLOAD": "Stiahnuť prepis",
      "COPY": "Kopírovať prepis"
    },
    "INVISIBLE_TO_CUSTOMER": "Neviditeľné pre zákazníka",
    "SENT_VIA_EMAIL": "Odoslané kontaktu aj e-mailom ({time})",
    "API_HOURS_WINDOW": "Na túto konverzáciu môžete odpovedať iba do {hours} hodín",
    "FACEBOOK_CANNOT_REPLY": "Ak potrebujete pokračovať v tejto konverzácii, ",
    "PENDING_WITH_BOT_BANNER": "Túto konverzáciu spracováva AI bot. Ak chcete odpovedať, najprv otvorte konverzáciu.",
    "INBOX_DELETE_REQUESTED_BANNER": "Táto schránka je označená na odstránenie, takže odpoveď zákazníka by nikdy nedorazila. Ak chcete odpovedať, presuňte konverzáciu do inej schránky.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Tento kontakt má ďalšiu otvorenú konverzáciu #{id}",
      "MULTIPLE": "Tento kontakt má ďalšie otvorené konverzácie ({count})",
      "OPEN": "Otvoriť",
      "SHOW": "Zobraziť"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Tento účet Instagramu bol migrovaný do novej schránky kanála Instagram. Všetky nové správy sa zobrazia tam. Z tejto konverzácie už nebudete môcť odosielať správy.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Nie je možné odoslať správu, pretože zákazník nie je online a kontinuita e-mailu nie je k dispozícii.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Zákazník nie je online. Možno nedostane správy, pretože kontinuita e-mailu nie je k dispozícii.",
    "OPEN_FILE": "Otvoriť",
    "DOWNLOAD_ATTACHMENTS": "Stiahnuť všetko",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Stiahnuť všetky prílohy jednu po druhej",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Stiahnuť všetko ako ZIP",
    "ERROR_DOWNLOADING_FILE": "Chyba pri sťahovaní súboru",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Požiadať zákazníka o zdieľanie telefónneho čísla WhatsApp",
      "PENDING_ACTION": "Žiadosť o kontaktné údaje čaká na vybavenie",
      "STATES": {
        "PENDING": "Čaká sa na kontaktné údaje",
        "SHARED": "Telefónne číslo bolo zdieľané",
        "IDENTITY_CONFLICT": "Telefónne číslo je potrebné skontrolovať"
      }
    },
    "IMAGE_UPLOAD_ERROR": "Nepodarilo sa nahrať obrázok, skúste to prosím znova",
    "DRAFT": {
      "FILE_TOO_LARGE": "Súbor '{fileName}' ({fileSize}) je príliš veľký pre uloženie konceptu a bude preskočený",
      "ATTACHMENT_SERIALIZATION_FAILED": "Nepodarilo sa serializovať prílohu pre uloženie konceptu",
      "STORAGE_QUOTA_EXCEEDED": "Prekročená kvóta úložiska. Koncept bol uložený bez príloh",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Nepodarilo sa uložiť koncept ani bez príloh",
      "SAVE_FAILED": "Nepodarilo sa uložiť koncept konverzácie"
    },
    "COMMENT_TREE": {
      "TITLE": "Vlákno komentárov",
      "EMPTY": "Žiadne komentáre na zobrazenie",
      "VIEW_TREE": "Zobraziť vlákno komentárov"
    },
    "MESSAGE_EVENT": {
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Volané klapky:",
          "CALL_COMPLETED": "Hovor dokončený",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "zdvihnuté inde, zvonilo {duration}",
            "NO_ANSWER": "nezdvihnuté, zvonilo {duration}",
            "REJECTED": "odmietnuté, zvonilo {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operátor",
            "QUEUE": "Fronta",
            "RING_GROUP": "Skupina"
          },
          "INBOUND_CALL": "Prichádzajúci hovor od {number} na {did}",
          "IVR_HANDLED": "Spracované IVR automatom",
          "IVR_LABEL_NOT_FOUND": "Chcel som priradiť štítok {name}, ale už neexistuje, prosím skontrolujte nastavenia.",
          "CALL_MISSED": "Zmeškaný hovor",
          "CALL_NO_ANSWER": "Nedovolali sme sa",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Automaticky vyriešené po neúspešných spätných volaniach: {count}",
          "OUTBOUND_CALL": "Odchádzajúci hovor od {agentName} z {did} na {number}",
          "SUMMARY_NOT_AVAILABLE": "Nepodarilo sa vygenerovať zhrnutie.",
          "RECORDING_DELETED": "Nahrávka hovoru bola odstránená používateľom {name}, {date}"
        }
      },
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Konverzáciu označil ako vyriešenú používateľ {userName}",
          "RESOLVED_WITHOUT_CSAT": "Konverzáciu označil ako vyriešenú {userName} (bez CSAT)",
          "CONTACT_RESOLVED": "Konverzáciu vyriešil kontakt {contactName}",
          "OPEN": "Konverzáciu znovu otvoril používateľ {userName}",
          "PENDING": "Konverzáciu označil ako čakajúcu používateľ {userName}",
          "SNOOZED": "Konverzáciu odložil používateľ {userName}",
          "AUTO_RESOLVED_INACTIVE": "Konverzácia bola označená ako vyriešená systémom kvôli {duration} hodinám neaktivity",
          "AUTO_RESOLVED": "Konverzácia bola označená ako vyriešená systémom.",
          "AUTO_RESOLVED_EMPTY": "Konverzácia bola označená ako vyriešená systémom, pretože bola prázdna.",
          "SYSTEM_AUTO_OPEN": "Systém znovu otvoril konverzáciu kvôli novej prichádzajúcej správe.",
          "AUTO_REOPENED": "Systém znovu otvoril konverzáciu po uplynutí stíšenia.",
          "BLOCKED_CONTACT_RESOLVED": "Systém vyriešil konverzáciu, pretože kontakt je blokovaný.",
          "KAUFLAND_TICKET_CLOSED": "Systém vyriešil konverzáciu, pretože ticket bol uzavretý na Kauflande."
        },
        "PRIORITY": {
          "ADDED": "{userName} nastavil prioritu na {newPriority}",
          "UPDATED": "{userName} zmenil prioritu z {oldPriority} na {newPriority}",
          "REMOVED": "{userName} odstránil prioritu"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} si priradil túto konverzáciu",
          "ASSIGNED": "Pridelené {assigneeName} od {userName}",
          "REMOVED": "Konverzácia nepriradená {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Pridelené tímu {teamName} od {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Pridelené {assigneeName} prostredníctvom tímu {teamName} od {userName}",
          "REMOVED": "Odpriradené z tímu {teamName} od {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} pridal štítok {labels}",
          "REMOVED": "{userName} odobral štítok {labels}"
        },
        "SLA": {
          "ADDED": "{userName} pridal SLA politiku {slaName}",
          "REMOVED": "{userName} odstránil SLA politiku {slaName}",
          "UPDATED": "{userName} upravil SLA politiku {slaName}"
        },
        "MUTED": "{userName} stlmil konverzáciu",
        "UNMUTED": "{userName} odtlmil konverzáciu",
        "CONTACT_BLOCKED": "{userName} zablokoval/a kontakt",
        "CONTACT_UNBLOCKED": "{userName} odblokoval/a kontakt",
        "DOMAIN_BLOCKED": "{userName} zablokoval všetky kontakty pre danú doménu",
        "DOMAIN_UNBLOCKED": "{userName} odblokoval všetky kontakty pre danú doménu",
        "MOVED": "{userName} presunul túto konverzáciu zo schránky {sourceInboxName} do schránky {targetInboxName}",
        "MOVED_BY_ORDER": "Presunuté, pretože objednávky kontaktu sú len z e-shopu {storeName} (posledná objednávka {orderId}), ktorého robot odpovedá v tejto schránke.",
        "MERGED": "{userName} zlúčil konverzáciu #{sourceId} do tejto konverzácie",
        "AUTOMATION_RULE_TRIGGERED": "Automatizačné pravidlo \"{ruleName}\" spustené",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automatizačné pravidlo \"{ruleName}\" zakázalo automatickú prioritu",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automatizačné pravidlo \"{ruleName}\" zakázalo automatické štítkovanie",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automatizačné pravidlo \"{ruleName}\" zastavilo ďalšie spracovanie pravidiel",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Odoslanie správy bolo preskočené pre túto automatickú odpoveď",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatizácia bola preskočená, pretože kontakt je blokovaný",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatizácia \"{ruleName}\" nemohla presunúť túto konverzáciu zo schránky {sourceInboxName} do schránky {targetInboxName}, pretože schránky nie sú kompatibilné.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatizácia \"{ruleName}\" nemohla presunúť túto konverzáciu zo schránky {sourceInboxName} do schránky {targetInboxName}, pretože kontakt nemá e-mailovú adresu.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatizácia \"{ruleName}\" nemohla odoslať správu: táto telefónna schránka nemôže posielať SMS, pretože účet nemá žiadnu SMS schránku. Pravidlo bolo vypnuté a administrátori dostali e-mail.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatizácia \"{ruleName}\" nemohla odoslať správu: prílohy z tejto schránky nie je možné odoslať cez SMS. Pravidlo bolo vypnuté a administrátori dostali e-mail.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makro \"{macroName}\" neodoslalo správu: táto telefónna schránka nemôže posielať SMS, pretože účet nemá žiadnu SMS schránku.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makro \"{macroName}\" neodoslalo správu: prílohy z tejto schránky nie je možné odoslať cez SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makro \"{macroName}\" neodoslalo správu: konverzáciu rieši bot. Najprv konverzáciu otvorte.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makro \"{macroName}\" neodoslalo správu: táto schránka je označená na odstránenie. Najprv presuňte konverzáciu do inej schránky.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatizácia \"{ruleName}\" odoslala e-mail na {contactEmail} v novej konverzácii [#{conversationId}]({conversationPath}) v schránke {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatizácia \"{ruleName}\" založila túto konverzáciu na základe konverzácie [#{conversationId}]({conversationPath}) v schránke {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatizácia \"{ruleName}\" nemohla odoslať správu v novej konverzácii v schránke {inboxName}, pretože kontakt nemá e-mailovú adresu.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatizácia \"{ruleName}\" odoslala SMS na {contactPhone} v novej konverzácii [#{conversationId}]({conversationPath}) v schránke {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatizácia \"{ruleName}\" nemohla odoslať SMS v novej konverzácii v schránke {inboxName}, pretože kontakt nemá telefónne číslo.",
        "AUTO_LABELING": {
          "REASONING": "Použité štítky: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Aktualizovaná priorita: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Zákazník"
          }
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Odoslať prepis konverzácie",
    "DESC": "Odoslať prepis konverzácie na špecifikovanú e-mailovú adresu",
    "SUBMIT": "Odoslať",
    "CANCEL": "Zrušiť",
    "SEND_EMAIL_SUCCESS": "Prepis chatu bol úspešne odoslaný",
    "SEND_EMAIL_ERROR": "Vyskytla sa chyba, skúste to prosím znova",
    "FORM": {
      "SEND_TO_CONTACT": "Odoslať prepis chatu zákazníkovi",
      "SEND_TO_AGENT": "Odoslať prepis pridelenému agentovi",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Odoslanie prepisu na inú emailovú adresu",
      "EMAIL": {
        "PLACEHOLDER": "Zadať e-mailovú adresu",
        "ERROR": "Prosím zadajte platnú e-mailovú adresu"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Ahoj 👋, vitaj v {installationName}!",
    "DESCRIPTION": "Ďakujeme za registráciu. Chceme, aby ste z {installationName} vyťažili čo najviac. Tu je niekoľko vecí, ktoré môžete urobiť v {installationName}, aby ste si spríjemnili zážitok.",
    "GREETING_MORNING": "👋 Dobré ráno, {name}. Vitajte v {installationName}.",
    "GREETING_AFTERNOON": "👋 Dobré popoludnie, {name}. Vitajte v {installationName}.",
    "GREETING_EVENING": "👋 Dobrý večer, {name}. Vitajte v {installationName}.",
    "READ_LATEST_UPDATES": "Prečítajte si naše novinky",
    "ALL_CONVERSATION": {
      "TITLE": "Všetky vaše konverzácie na jednom mieste",
      "DESCRIPTION": "Zobrazte si všetky konverzácie od svojich zákazníkov na jednom ovládacom paneli. Konverzácie môžete filtrovať podľa prichádzajúceho kanála, štítku a statusu.",
      "NEW_LINK": "Kliknite sem pre vytvorenie schránky"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Pozvite členov svojho tímu",
      "DESCRIPTION": "Keďže sa chystáte rozprávať so svojím zákazníkom, zapojte svojich spolupracovníkov na pomoc. Členov tímu môžete pozvať pridaním ich e-mailových adries do zoznamu agentov.",
      "NEW_LINK": "Kliknite sem pre pozvanie člena tímu"
    },
    "LABELS": {
      "TITLE": "Usporiadajte si konverzácie pomocou štítkov",
      "DESCRIPTION": "Štítky umožňujú jednoduchšie kategorizovať konverzáciu. Vytvorte si niekoľko štítkov, napríklad #podpora-dotaz, #vyuctovanie-otazka atď., aby ste ich mohli neskôr použiť v konverzácii.",
      "NEW_LINK": "Kliknutím sem vytvoríte tagy"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Vytvoriť pripravené odpovede",
      "DESCRIPTION": "Preddefinované šablóny rýchlych odpovedí vám pomôžu rýchlo reagovať na konverzáciu. Agenti môžu napísať znak '/' nasledovaný skráteným kódom, aby vložili odpoveď.",
      "NEW_LINK": "Kliknite sem pre vytvorenie pripravenej odpovede"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Pridelený agent",
    "SELF_ASSIGN": "Prideliť mne",
    "TEAM_LABEL": "Pridelený tím",
    "SELECT": {
      "PLACEHOLDER": "Žiadne"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Vlastné dáta",
      "CONTACT_DETAILS": "Konktaktné detaily",
      "CONVERSATION_ACTIONS": "Akcie konverzácie",
      "CONVERSATION_LABELS": "Označenia konverzácii",
      "CONVERSATION_INFO": "Informácie o konverzácii",
      "CONTACT_ATTRIBUTES": "Atribúty kontaktu",
      "PREVIOUS_CONVERSATION": "Prechádzajúce konverzácie",
      "MACROS": "Makrá",
      "SHOPIFY_ORDERS": "Shopify objednávky",
      "ORDER_HISTORY": "História objednávok",
      "RETINO_TICKETS": "Retino tickety"
    },
    "SHOPIFY": {
      "ORDER_ID": "Objednávka #{id}",
      "ERROR": "Chyba pri načítaní objednávok",
      "NO_SHOPIFY_ORDERS": "Nenašli sa žiadne objednávky",
      "FINANCIAL_STATUS": {
        "PENDING": "Čaká sa na",
        "AUTHORIZED": "Autorizované",
        "PARTIALLY_PAID": "Čiastočne zaplatené",
        "PAID": "Zaplatené",
        "PARTIALLY_REFUNDED": "Čiastočne vrátené",
        "REFUNDED": "Vrátené",
        "VOIDED": "Zrušené"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Vybavené",
        "PARTIALLY_FULFILLED": "Čiastočne vybavené",
        "UNFULFILLED": "Nevybavené"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Vytvoriť atribút",
    "NO_RECORDS_FOUND": "Žiadne atribúty neboli nájdené",
    "UPDATE": {
      "SUCCESS": "Atribút úspešne nahraný",
      "ERROR": "Nie je možné aktualizovať atribút. Skúste to prosím neskôr"
    },
    "ADD": {
      "TITLE": "Pridať",
      "SUCCESS": "Nový atribút úspešne pridaný",
      "ERROR": "Nebolo možné pridať atribút. Skúste to prosím neskôr"
    },
    "DELETE": {
      "SUCCESS": "Aitribút úspešne vymazaný",
      "ERROR": "Nie je možné odstrániť atribút. Skúste to prosím neskôr"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Pridať atribúty",
      "PLACEHOLDER": "Hľadať atribúty",
      "NO_RESULT": "Žiadne atribúty neboli nájdené"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Od",
    "TO": "Pre",
    "BCC": "Skrytá kópia",
    "CC": "Kópia",
    "SUBJECT": "Predmet"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Zúčastňujúci sa",
    "SIDEBAR_TITLE": "Účastníci konverzácie",
    "NO_RECORDS_FOUND": "Žiadne výsledky neboli nájdené",
    "ADD_PARTICIPANTS": "Vybrať účastníkov",
    "SEARCH_PLACEHOLDER": "Hľadať",
    "REMANING_PARTICIPANTS_TEXT": "+{count} ďalších",
    "REMANING_PARTICIPANT_TEXT": "+{count} ďalší",
    "TOTAL_PARTICIPANTS_TEXT": "Zúčastňuje sa {count} ľudí.",
    "TOTAL_PARTICIPANT_TEXT": "Zúčastňuje sa {count} osoba.",
    "NO_PARTICIPANTS_TEXT": "Nikto sa nezúčastňuje!",
    "WATCH_CONVERSATION": "Pripojiť sa ku konverzácii",
    "YOU_ARE_WATCHING": "Zúčastňujete sa",
    "API": {
      "ERROR_MESSAGE": "Nepodarilo sa aktualizovať, skúste znova!",
      "SUCCESS_MESSAGE": "Účastníci aktualizovaní!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Zobraziť preložený obsah",
    "DESC": "Preložený obsah si môžete zobraziť v každom jazyku.",
    "ORIGINAL_CONTENT": "Pôvodný obsah",
    "TRANSLATED_CONTENT": "Preložený obsah",
    "NO_TRANSLATIONS_AVAILABLE": "Pre tento obsah nie sú dostupné žiadne preklady"
  },
  "TYPING": {
    "ONE": "{user} píše",
    "TWO": "{user} a {secondUser} píšu",
    "MULTIPLE": "{user} a {count} ďalších píše",
    "IMAGE_ALT": "Niekto píše"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Vyskúšajte tieto výzvy"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Nepodarilo sa stiahnuť prílohu. Skúste to prosím znova"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Nenašli sa žiadne dáta",
    "LOAD_ERROR": "Nepodarilo sa načítať dáta. Skúste to znova neskôr."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Načítať viac",
    "NO_RECORDS_FOUND": "Neboli nájdené žiadne tickety",
    "LOAD_ERROR": "Nie je možné načítať tickety z {hookName}. Skúste to prosím neskôr.",
    "NOT_SEARCHABLE": "E-mail kontaktu nie je nastavený.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Načítava sa...",
    "NO_ORDERS": "Neboli nájdené žiadne objednávky",
    "NOT_AVAILABLE": "Údaje zákazníka nie sú k dispozícii",
    "EXPAND": "Otvoriť profil zákazníka",
    "MORE_ITEMS": "+ {count} položiek",
    "EXPEDITION_STATUS": "Stav expedície",
    "OPEN_DETAIL": "otvoriť detail",
    "COPY_ORDER_ID": "Číslo objednávky",
    "EXTERNAL_ID": "Variabilný symbol",
    "PAYMENT_TYPE": "Spôsob platby",
    "PAYMENT_DATE": "Dátum platby",
    "DELIVERY_PROVIDER": "Dopravca",
    "EXPECTED_DATE_OF_DELIVERY": "Očakávané doručenie",
    "DATE_OF_DELIVERY": "Doručené",
    "EXPEDITION_DATE": "Dátum expedície",
    "INTERNAL_NOTE": "Poznámka e-shopu",
    "PACKAGE_NUMBER": "Zásielka"
  },
  "READING": {
    "ONE": "{user} číta tento ticket",
    "TWO": "{user} a {secondUser} čítajú tento ticket",
    "MULTIPLE": "{user} a {count} ďalších čítajú tento ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Presunúť konverzáciu",
    "DESCRIPTION": "Presunúť túto konverzáciu do inej e-mailovej schránky.",
    "SOURCE": {
      "TITLE": "Konverzácia",
      "ID_LABEL": "ID konverzácie"
    },
    "TARGET": {
      "TITLE": "Cieľová schránka",
      "PLACEHOLDER": "Vyberte e-mailovú schránku",
      "NO_RESULTS": "Nie sú dostupné žiadne iné e-mailové schránky",
      "ERROR": "Vyberte prosím cieľovú schránku"
    },
    "SUBMIT": "Presunúť konverzáciu",
    "CANCEL": "Zrušiť",
    "SUCCESS_MESSAGE": "Konverzácia bola úspešne presunutá",
    "ERROR_MESSAGE": "Nepodarilo sa presunúť konverzáciu. Skúste to prosím znova."
  },
  "MERGE": {
    "TITLE": "Zlúčiť konverzácie",
    "DESCRIPTION": "Zlúčiť túto konverzáciu s inou konverzáciou. Všetky správy z tejto konverzácie budú presunuté do cieľovej konverzácie a táto konverzácia bude vymazaná.",
    "SOURCE": {
      "TITLE": "Zdrojová konverzácia (bude vymazaná)",
      "ID_LABEL": "ID konverzácie"
    },
    "TARGET": {
      "TITLE": "Cieľová konverzácia",
      "PLACEHOLDER": "Zadajte ID konverzácie pre vyhľadávanie (napr. 123)",
      "HELP": "Zadajte ID konverzácie, do ktorej sa majú zlúčiť všetky správy.",
      "ERROR": "Vyberte prosím cieľovú konverzáciu"
    },
    "WARNING": "Varovanie: Túto akciu nie je možné vrátiť späť. Všetky správy budú presunuté do cieľovej konverzácie a táto konverzácia bude trvalo vymazaná.",
    "SUBMIT": "Zlúčiť konverzácie",
    "CANCEL": "Zrušiť",
    "SUCCESS_MESSAGE": "Konverzácia bola úspešne zlúčená",
    "ERROR_MESSAGE": "Nepodarilo sa zlúčiť konverzácie. Skontrolujte cieľovú konverzáciu a skúste to znova.",
    "SEARCH": {
      "NO_RESULTS": "Nebola nájdená konverzácia s týmto ID",
      "ERROR_MESSAGE": "Nepodarilo sa vyhľadať konverzácie. Skúste to prosím znova."
    },
    "CONFIRM": {
      "TITLE": "Potvrdiť zlúčenie",
      "DESCRIPTION": "Naozaj chcete zlúčiť túto konverzáciu? Túto akciu nie je možné vrátiť späť.",
      "YES": "Áno, zlúčiť",
      "CANCEL": "Zrušiť"
    }
  }
}
